﻿import type { Timestamp } from 'firebase/firestore';

export function formatDueShort(due: Timestamp | null | undefined): {
  text: string;
  overdue: boolean;
} {
  if (!due || typeof (due as Timestamp).toMillis !== 'function') {
    return { text: '', overdue: false };
  }
  const ms = (due as Timestamp).toMillis();
  const diff = ms - Date.now();
  const overdue = diff < 0;
  const abs = Math.abs(diff);
  if (abs < 3_600_000) {
    const mins = Math.floor(abs / 60_000);
    return { text: overdue ? `${mins}m late` : `${mins}m`, overdue };
  }
  if (abs < 86_400_000) {
    const hrs = Math.floor(abs / 3_600_000);
    return { text: overdue ? `${hrs}h late` : `${hrs}h`, overdue };
  }
  const days = Math.floor(abs / 86_400_000);
  return { text: overdue ? `${days}d late` : `${days}d`, overdue };
}
